var exports = {
  "k": "x31de4314--35d594--container",
};

module.exports = exports;
